// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"615":"3e5e68db","812":"74436cd9"}[chunkId] + ".chunk.css";
};